import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import FAQ from './components/FAQ';

const ContactPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://trackverse.com';

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://track-verse.com';
    document.title = 'Contactez TrackVerse — Support Logistique & Service Client | Ajaccio';
    document.documentElement.lang = 'fr';

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Contactez TrackVerse pour vos besoins logistiques, support client ou partenariat. Bureau à Ajaccio, disponible lundi-samedi 8h-19h. Email, téléphone ou formulaire de contact.');
    setMeta('keywords', 'contact TrackVerse, support logistique, service client, bureau Ajaccio, aide expédition, partenariat logistique');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); (canonical as HTMLLinkElement).rel = 'canonical'; document.head.appendChild(canonical); }
    (canonical as HTMLLinkElement).href = `${siteUrl}/contact`;

    setMeta('og:title', 'Contactez TrackVerse — Support & Service Client Logistique', true);
    setMeta('og:description', 'Support logistique disponible lundi-samedi 8h-19h. Bureau à Ajaccio, contact par email, téléphone ou formulaire.', true);
    setMeta('og:url', `${siteUrl}/contact`, true);
    setMeta('og:type', 'website', true);
    setMeta('og:image', `${siteUrl}/og-image.jpg`, true);
    setMeta('twitter:title', 'Contactez TrackVerse — Support Logistique Ajaccio');
    setMeta('twitter:description', 'Support disponible lundi-samedi 8h-19h. Bureau à Ajaccio.');
    setMeta('twitter:image', `${siteUrl}/og-image.jpg`);

    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "TrackVerse",
      "image": `${siteUrl}/og-image.jpg`,
      "url": `${siteUrl}/contact`,
      "telephone": "+33-4-95-00-00-00",
      "email": "info.trackverse@gmail.com",
      "priceRange": "$$",
      "address": { "@type": "PostalAddress", "streetAddress": "123 Avenue Napoléon", "addressLocality": "Ajaccio", "addressRegion": "Corse-du-Sud", "postalCode": "20000", "addressCountry": "FR" },
      "geo": { "@type": "GeoCoordinates", "latitude": "41.9267", "longitude": "8.7369" },
      "hasMap": "https://maps.google.com/?q=Ajaccio,Corse,France",
      "openingHoursSpecification": [
        { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "08:00", "closes": "19:00" },
        { "@type": "OpeningHoursSpecification", "dayOfWeek": "Saturday", "opens": "09:00", "closes": "17:00" }
      ],
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Accueil", "item": `${siteUrl}/` },
          { "@type": "ListItem", "position": 2, "name": "Contact", "item": `${siteUrl}/contact` }
        ]
      }
    };

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        { "@type": "Question", "name": "Dans quels pays TrackVerse opère-t-il ?", "acceptedAnswer": { "@type": "Answer", "text": "TrackVerse opère dans plus de 50 pays à travers l'Europe, l'Amérique, l'Afrique, l'Asie et l'Océanie." } },
        { "@type": "Question", "name": "Comment suivre mon envoi ?", "acceptedAnswer": { "@type": "Answer", "text": "Rendez-vous sur notre page de suivi et entrez votre numéro de suivi pour voir la localisation et le statut de votre colis en temps réel." } },
        { "@type": "Question", "name": "Quels sont vos horaires d'ouverture ?", "acceptedAnswer": { "@type": "Answer", "text": "Nous sommes disponibles du lundi au vendredi de 8h à 19h et le samedi de 9h à 17h depuis notre bureau à Ajaccio." } }
      ]
    };

    const schemas = [
      { id: 'contact-local-business', data: localBusinessSchema },
      { id: 'contact-faq', data: faqSchema }
    ];

    schemas.forEach(({ id, data }) => {
      let script = document.querySelector(`script[data-schema="${id}"]`);
      if (!script) { script = document.createElement('script'); script.setAttribute('type', 'application/ld+json'); script.setAttribute('data-schema', id); document.head.appendChild(script); }
      script.textContent = JSON.stringify(data);
    });

    return () => {
      schemas.forEach(({ id }) => { const s = document.querySelector(`script[data-schema="${id}"]`); if (s) s.remove(); });
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <ContactHero />
      <ContactInfo />
      <ContactForm />
      <FAQ />
      <Footer />
    </div>
  );
};

export default ContactPage;
